module.exports = __webpack_public_path__ + "img/non-smoking.1949b3f0.svg";